<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<form (keydown.enter)="confirmDelete(user.id.value)" (ngSubmit)="confirmDelete(user.id.value)" class="dialog-form" name="deleteForm">
    <div class="siklu-mat-dialog-title" matDialogTitle>
        <h4>{{ 'entity.delete.title' | translate }}</h4>
        <button matDialogClose windeClose>
            <sui-svg-icon icon="cross"/>
        </button>
    </div>
    <div *ngIf="user" class="siklu-mat-dialog-body" matDialogContent>
        <winde-alert-error></winde-alert-error>
        <p *ngIf="user">{{ 'userManagement.delete.question' | translate: {login: user.login.value | gtthTextEscape} }}</p>
    </div>
    <div class="siklu-mat-dialog-footer" matDialogActions>
        <button matDialogClose windeTransparent>
            <sui-svg-icon icon="cross"/>
            {{ 'entity.action.cancel' | translate }}
        </button>
        <button type="submit" windeRed>
            <sui-svg-icon icon="trash"/>
            {{ 'entity.action.delete' | translate }}
        </button>
    </div>
</form>
